module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attach-product-wrapper",
    style: (("background-color: " + _vm.backgroundColor)),
    attrs: {
      "id": _vm.divId
    }
  }, [_c('div', {
    staticClass: "block-heading-font-style"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "block-subheading-font-style"
  }, [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "product-item"
    }, [_c('SingleProductComponent', {
      attrs: {
        "product": product
      }
    })], 1)
  }), _vm._v(" "), _c('a', {
    staticClass: "mobile-cta-button",
    class: [_vm.shouldShowMainCta ? 'mobile-cta-button-visible' : 'mobile-cta-button-hidden'],
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": _vm.logCtaClick
    }
  }, [_vm._v("\n    " + _vm._s(_vm.mobileCta) + "\n  ")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b2d2fc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/AttachProductComponents/StudiosProductComponent.vue
// module id = 458
// module chunks = 0